import * as React from 'react';
const githubIcon = require('./components/images/github.svg').default;

const GithubLink = ({ link = 'https://google.com', text = 'this is the text' }) => {
  return (
    <a href={link} className="githubSection">
      <img className="githubIcon" src={githubIcon} alt="github" />
      {text}
    </a>
  );
};

export default GithubLink;
